import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Box } from "@mui/system";
import { Card, Container, Grid, Typography } from "@mui/material";
import client1 from '../../../images/client1.jpg';
import client2 from '../../../images/client2.jpg';

const Reviews = () => {
    const settings = {
        className: "center",
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 2,
        swipeToSlide: true,
        afterChange: function(index) {
          console.log(
            `Slider Changed to: ${index + 1}, background: '#222'; color: #bada55`
          );
        }
      };
    return (
        <Box sx={{ mt: 8, mb: 8 }}>
        <Typography variant="h4">
            My Customers Reviews
        </Typography>
        <Container sx={{ mt: 5 }}>
            <Slider {...settings}>
            <Card sx={{ p: 2, maxWidth: '500px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <img src={client1} style={{ width: '100%', height: '180px' }} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body1' style={{ 'textAlign': 'left' }}>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed ea cupiditate numquam quis harum inventore non esse vero repellat, quod commodi eum corrupti voluptatum doloribus aperiam delectus rem optio fuga.
                        </Typography>
                        <Typography variant='h6' style={{ 'textAlign': 'left' }}>
                            Jone Doe
                        </Typography>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ p: 2, maxWidth: '500px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <img src={client2} style={{ width: '100%', height: '180px' }} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body1' style={{ 'textAlign': 'left' }}>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed ea cupiditate numquam quis harum inventore non esse vero repellat, quod commodi eum corrupti voluptatum doloribus aperiam delectus rem optio fuga.
                        </Typography>
                        <Typography variant='h6'style={{ 'textAlign': 'left' }}>
                            Jone Doe
                        </Typography>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ p: 2, maxWidth: '500px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <img src={client1} style={{ width: '100%', height: '180px' }} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body1' style={{ 'textAlign': 'left' }}>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed ea cupiditate numquam quis harum inventore non esse vero repellat, quod commodi eum corrupti voluptatum doloribus aperiam delectus rem optio fuga.
                        </Typography>
                        <Typography variant='h6' style={{ 'textAlign': 'left' }}>
                            Jone Doe
                        </Typography>
                    </Grid>
                </Grid>
            </Card>
            <Card sx={{ p: 2, maxWidth: '500px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <img src={client2} style={{ width: '100%', height: '180px' }} alt="" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant='body1' style={{ 'textAlign': 'left' }}>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sed ea cupiditate numquam quis harum inventore non esse vero repellat, quod commodi eum corrupti voluptatum doloribus aperiam delectus rem optio fuga.
                        </Typography>
                        <Typography variant='h6' style={{ 'textAlign': 'left' }}>
                            Jone Doe
                        </Typography>
                    </Grid>
                </Grid>
            </Card>

            </Slider>
        </Container>
      </Box>
    );
};

export default Reviews;